export default "__VITE_ASSET__8478161e__"